import React, { Component } from 'react';

export default class DailyMotionPlayer extends Component {
  constructor() {
    super();

    const self = this;

    this._currentTime = 0;
    this.duration = 0;
    this._muted = false;
    this.duration = 1;
    this.loaded = false;
    this.ended = false;
    this.paused = false;

    Object.defineProperty(this, 'currentTime', {
      get: () => self._currentTime,
      set: (newValue) => self.seek(newValue),
    });

    Object.defineProperty(this, 'muted', {
      get: () => self._muted,
      set: (newValue) => self.mute(newValue),
    });

    Object.defineProperty(this, 'offsetHeight', {
      get: () => this.refs.iframe.offsetHeight,
    });

    Object.defineProperty(this, 'offsetWidth', {
      get: () => this.refs.iframe.offsetWidth,
    });

    Object.defineProperty(this, 'videoHeight', {
      get: () => 720,
    });

    Object.defineProperty(this, 'videoWidth', {
      get: () => 1280,
    });
  }

  deparam(querystring) {
    // remove any preceding url and split
    querystring = querystring
      .substring(querystring.indexOf('?') + 1)
      .split('&');
    var params = {},
      pair,
      d = decodeURIComponent;
    // march and parse
    for (var i = querystring.length - 1; i >= 0; i--) {
      pair = querystring[i].split('=');
      params[d(pair[0])] = d(pair[1] || '');
    }

    return params;
  }

  onMessage(e) {
    if (e.origin.indexOf('dailymotion') === -1) {
      return;
    }
    const self = this;
    const data = self.deparam(e.data);
    switch (data.event) {
      case 'timeupdate':
        self._currentTime = parseFloat(data.time);
        self.props.onTimeUpdate();
        break;
      case 'durationchange':
        console.warn('Init duration ' + data.duration.toString());
        self.duration = parseFloat(data.duration);
        if (!self.loaded) {
          self.props.onLoadedData();
          self.loaded = true;
        }
        break;
      case 'playing':
        self.ended = false;
        break;
      case 'ended':
        self.ended = true;
        break;
      default:
        console.warn(data);
    }
  }

  componentDidMount() {
    window.addEventListener('message', this.onMessage.bind(this), false);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.onMessage);
  }

  play() {
    this.refs.iframe.contentWindow.postMessage(
      '{"command":"play","parameters":[]}',
      '*'
    );
  }
  pause() {
    this.refs.iframe.contentWindow.postMessage(
      '{"command":"pause","parameters":[]}',
      '*'
    );
  }
  seek(time) {
    this.refs.iframe.contentWindow.postMessage(
      `{"command":"seek","parameters":[${time}]}`,
      '*'
    );
  }
  mute(muted) {
    this.refs.iframe.contentWindow.postMessage(
      `{"command":"setMuted","parameters":[${muted}]}`,
      '*'
    );
    this._muted = muted;
  }
  render() {
    return (
      <iframe
        title="DailyMotion Player"
        ref="iframe"
        frameBorder="0"
        width="100%"
        height="304px"
        src={`//www.dailymotion.com/embed/video/${this.props.videoId}?api=postMessage&controls=false&autoplay=true&loop=true`}
      />
    );
  }
}
